import React from 'react';
import PropTypes from 'prop-types';

function Footer(props) {
  return (
    <footer className="footer">
      <div className="g-row">
        <div className="g-col">
          <p className="hr">{props.copyright}</p>
          {props.description && (
            <p style={{ fontStyle: 'italic' }}>{props.description}</p>
          )}
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  copyright: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/views/components/footer/index.js